import getBlockRect from '../../utils/getBlockRect';
import getRangeRect from '../../utils/getRangeRect';
export default function isAtFirstLineOfBlock(editor) {
  var parentRect = getBlockRect(editor, editor.value.startBlock);
  var selectionRect = getRangeRect(editor, editor.value.selection);
  return Math.floor(Math.abs(selectionRect.top - parentRect.top)) === 0;
}